import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const SmartGroupsModal = ({ open, onOpenChange, suggestions, onApply }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="modal-dark sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="font-serif text-[#FDF8EE] flex items-center gap-2">
          <span className="text-[#7AB8A0]">◎</span> Smart Groups
        </DialogTitle>
        <DialogDescription className="font-mono text-[9px] text-[#4A3A1A]">
          Ryan found patterns in your uncategorized entries. Create volumes with one click.
        </DialogDescription>
      </DialogHeader>
      <div className="py-3 space-y-3 max-h-[60vh] overflow-y-auto">
        {suggestions.map((suggestion, idx) => (
          <div key={idx} className="bg-[rgba(122,184,160,0.04)] border border-[rgba(122,184,160,0.12)] p-4" data-testid={`smart-group-${idx}`}>
            <div className="flex items-center justify-between mb-2">
              <h4 className="font-serif font-bold text-[#FDF8EE] text-sm">{suggestion.suggested_name}</h4>
              <span className="font-mono text-[8px] text-[#7AB8A0] bg-[rgba(122,184,160,0.12)] px-1.5 py-0.5">{suggestion.count} entries</span>
            </div>
            <div className="space-y-1 mb-3">
              {suggestion.bookmark_previews.map((bm, j) => (
                <p key={j} className="text-[11px] text-[#8C7A5A] truncate leading-[1.4]">
                  <span className="text-[#4A3A1A] mr-1.5">·</span>{bm.content}
                </p>
              ))}
              {suggestion.count > 5 && <p className="text-[10px] text-[#4A3A1A] italic">+{suggestion.count - 5} more entries</p>}
            </div>
            <button onClick={() => onApply(suggestion)} className="btn-primary text-xs py-1.5 px-4" data-testid={`apply-group-${idx}`}>Create Volume →</button>
          </div>
        ))}
        {suggestions.length === 0 && <p className="text-sm text-[#8C7A5A] text-center py-6">No grouping suggestions yet. Save more entries to see patterns.</p>}
      </div>
    </DialogContent>
  </Dialog>
);
